import DrawingsItemMenu from './DrawingsItemMenu.tsx';
import { DateService } from '../../services/DateService.ts';
import { Badge } from 'lucide-react';
import { getDrawingUrl } from '../../config/Config.ts';

const DrawingsItem = (props: any) => {
  const { drawing } = props;

  return (
    <div className="p-3 bg-card border-border border rounded cursor-pointer">
      <div className="mb-3">
        <img src={getDrawingUrl(drawing.file)} className="aspect-[3/4]" alt={drawing.name} />
      </div>
      <div className="flex justify-between items-center mb-1">
        <div className="text-base flex items-center line-clamp-1 w-full flex-1">
          <Badge className={`w-4 h-4 ${drawing.status === 'ACTIVE' ? 'text-primary fill-primary' : 'text-text fill-text'}`} /> &nbsp; {drawing.name}
        </div>
        <DrawingsItemMenu drawing={drawing} />
      </div>
      <div className="text-sm text-muted leading-relaxed">
        {drawing.user?.name} &middot; {DateService.format(drawing.created)}
      </div>
    </div>
  );
};

export default DrawingsItem;
